import { render, staticRenderFns } from "./workerPool2Wx.vue?vue&type=template&id=531f7fdf&scoped=true&"
import script from "./workerPool2Wx.vue?vue&type=script&lang=js&"
export * from "./workerPool2Wx.vue?vue&type=script&lang=js&"
import style0 from "./workerPool2Wx.vue?vue&type=style&index=0&lang=css&"
import style1 from "./workerPool2Wx.vue?vue&type=style&index=1&id=531f7fdf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531f7fdf",
  null
  
)

export default component.exports